import apiService from 'frontcore/data/api-service/api-service'
import { AuditFieldConfiguration, AuditSource } from 'frontend/store/sources/types'

export class AuditSourceAPIServiceError extends Error {}

export type AuditFieldConfigurationAPIResponse = {
  id: number
  name: string
  active: boolean
  mandatory: boolean
  allow_multiple_selection: boolean
}

export type AuditSourceAPIResponse = {
  id: number
  dashboard_icon: string
  enabled: boolean
  field_configs: AuditFieldConfigurationAPIResponse[]
  include_compliance_plan: boolean
  is_master_audit_source: boolean
  localized_name: string
  name: string
  number_of_templates: number
  plan_standards: boolean
  score_goal: number
}

const parseAuditFieldConfigResponse = (data: AuditFieldConfigurationAPIResponse): AuditFieldConfiguration => {
  return {
    id: data.id,
    name: data.name,
    active: data.active,
    mandatory: data.mandatory,
    isMultipleSelection: data.allow_multiple_selection,
  }
}

const parseAuditSourceResponse = (data: AuditSourceAPIResponse): AuditSource => {
  return {
    id: data.id,
    dashboardIcon: data.dashboard_icon,
    enabled: data.enabled,
    fieldConfigs: data.field_configs.map(parseAuditFieldConfigResponse),
    includeCompliancePlan: data.include_compliance_plan,
    isMasterAuditSource: data.is_master_audit_source,
    localizedName: data.localized_name,
    name: data.name,
    templatesAmount: data.number_of_templates,
    planStandards: data.plan_standards,
    scoreGoal: data.score_goal,
  }
}

interface IAuditSourceAPIService {
  fetch: () => Promise<AuditSource[]>
}

export default class AuditSourceAPIService implements IAuditSourceAPIService {
  static readonly url = '/source-audits/'

  async fetch (): Promise<AuditSource[]> {
    try {
      const response = await apiService
        .buildRequest()
        .withSessionToken()
        .get<AuditSourceAPIResponse[]>(AuditSourceAPIService.url)
      return response.data.map(parseAuditSourceResponse)
    } catch {
      throw new AuditSourceAPIServiceError('common.errors.unexpected_error')
    }
  }
}
